<template>
    <dialog-window
        :show="show"
        v-bind="dialogProps"
        :closeOnEscape="true"
        @closed="onOk"
        style="z-index: 1007;"
    >
        <template v-if="header" v-slot:header>
            <i v-show="headerIcon" :class="headerIcon" style="margin-right: 0.3em"></i>
            {{ header }}
        </template>
        <template v-if="type === 'alert'" v-slot:body>
            <component
                v-bind="bodyComponentProps"
                :is="componentName"
                v-if="componentName"
                @closed="onOk"
            ></component>
            <div v-else v-html="body" class="info-label"></div>
        </template>
        <template v-slot:footer>
            <button
                class="button primary icon"
                ref="ok"
                @click="onOk"
                :style="okStyles"
            >
                <i v-show="okIcon" :class="okIcon"></i>
                {{ okText }}
            </button>
        </template>
    </dialog-window>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'DialogAlert',
        data() {
            return {};
        },
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                header: 'dialog/header',
                headerIcon: 'dialog/headerIcon',
                okText: 'dialog/okText',
                okIcon: 'dialog/okIcon',
                okStyles: 'dialog/okStyles',
                componentName: 'dialog/componentName',
                bodyComponentProps: 'dialog/bodyComponentProps',
                dialogProps: 'dialog/dialogProps',
                body: 'dialog/body',
                ok: 'dialog/ok',
                type: 'dialog/type'
            })
        },
        methods: {
            onOk() {
                this.ok();
                this.$store.dispatch('dialog/clear');
            }
        }
    };
</script>